import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { ExerciseUser } from "../../models/exercise.model";

@Component({
  selector: "ngx-view-exercise-user-card",
  styleUrls: ["./view-exercise-user-card.component.scss"],
  templateUrl: "./view-exercise-user-card.component.html",
})
export class ViewExerciseUserCardComponent implements OnInit {
  @Input() exerciseUser: ExerciseUser;
  @Input() mode?: string; //detail / other / home
  @Output() onRedirect: EventEmitter<any> = new EventEmitter();

  constructor(private router: Router) {}

  ngOnInit(): void {}

  onClick() {
    //this.onRedirect.emit(true);
  }
}
